import { styled, Typography, TypographyProps } from '@mui/material';

export const Colon = styled((props: TypographyProps) => <Typography {...props}>:</Typography>)(
  ({ theme }) => ({
    fontSize: theme.typography.pxToRem(64),
    color: theme.palette.common.black,
  })
);
